import { FC, useMemo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { flatten } from 'lodash';

const CheckmateLinkRenderer: FC<ICellRendererParams> = (props: ICellRendererParams) => {

  const transformEachValue = (value: string): string => {
    if (!!(value as string || '')?.toLowerCase && (value as string || '')?.toLowerCase()?.startsWith('darkweb')) {
      return value;
    }
    if (value && !!(value as string || '')?.toLowerCase && !(value as string || '')?.toLowerCase()?.startsWith('http')) {
      return `http://${value}`;
    }
    return value || ''
  }

  const value = useMemo(() => {
    if (Array.isArray(props.value) && props.value?.length) {
      const returnValue = props.value.map((value) => {
        if (value.indexOf(',') > -1) {
          return value.split(',').map((innerValue) => {
            return transformEachValue(innerValue);
          })
        } else {
          return transformEachValue(value);
        }
      })
      return returnValue;
    }
    return transformEachValue(props.value);
  }, [props.value]);

  const mapValues = (url: string, index: number) => {
    if (url?.startsWith('http')) {
        return <div key={index}><a href={url} target={'_blank'}>{url}</a><br/></div>
    } else {
        return <div key={index}><span>{url}</span><br/></div>
    }
  }
  
  return <div className="line-break-cell">
    {Array.isArray(value) && !!value?.length && flatten(value).map((source, index) => {
      return mapValues(source, index);
    })}
    {typeof value === 'string' && mapValues(value, 0)}
  </div>
};

export default CheckmateLinkRenderer